import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, Switch, message } from 'antd';
import { faqApi } from '../../services/api';
import { FaqItem } from '../../services/types';

interface FaqFormModalProps {
    open: boolean;
    onCancel: () => void;
    onSuccess: () => void;
    editData?: FaqItem;
}

const FaqFormModal: React.FC<FaqFormModalProps> = ({ open, onCancel, onSuccess, editData }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = React.useState(false);

    useEffect(() => {
        if (open) {
            if (editData) {
                form.setFieldsValue({
                    question: editData.question,
                    answer: editData.answer,
                    category: editData.category,
                    tags: editData.tags,
                    is_active: editData.is_active,
                });
            } else {
                form.resetFields();
                form.setFieldsValue({ is_active: true });
            }
        }
    }, [open, editData, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);

            if (editData) {
                await faqApi.update(editData.id, values);
                message.success('更新成功');
            } else {
                await faqApi.create(values);
                message.success('创建成功');
            }

            onSuccess();
        } catch (error: any) {
            if (error.errorFields) return;
            message.error(editData ? '更新失败' : '创建失败');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title={editData ? '编辑 FAQ' : '新增 FAQ'}
            open={open}
            onCancel={onCancel}
            onOk={handleSubmit}
            confirmLoading={submitting}
            destroyOnClose
            width={600}
            okText="保存"
            cancelText="取消"
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{ is_active: true }}
                style={{ marginTop: 24 }}
            >
                <Form.Item
                    name="question"
                    label="问题 (Q)"
                    rules={[{ required: true, message: '请输入问题内容' }]}
                >
                    <Input.TextArea placeholder="请输入会触发此 FAQ 的潜在用户问题或标准问法..." autoSize={{ minRows: 2, maxRows: 4 }} />
                </Form.Item>

                <Form.Item
                    name="answer"
                    label="解答 (A)"
                    rules={[{ required: true, message: '请输入解答内容' }]}
                >
                    <Input.TextArea placeholder="请输入提供给用户的标准解答..." autoSize={{ minRows: 4, maxRows: 8 }} />
                </Form.Item>

                <Form.Item name="category" label="文档分类">
                    <Select placeholder="请选择或输入分类">
                        <Select.Option value="技术">技术</Select.Option>
                        <Select.Option value="产品">产品</Select.Option>
                        <Select.Option value="服务">服务</Select.Option>
                        <Select.Option value="其他">其他</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item name="tags" label="标签">
                    <Input placeholder="输入标签，多个标签用逗号(,)分隔，例如：退换货,流程" />
                </Form.Item>

                <Form.Item name="is_active" label="是否启用" valuePropName="checked">
                    <Switch />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default FaqFormModal;
